import React,{useEffect,useState, useRef} from "react";
import Select , { components } from "react-select";
import "./index.css";

const Styles = {
  control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      width: "100%",
  }),
  option: (provided, state) => ({
      ...provided,
      fontSize: 14,
      display: "flex",
      flexDirection: "row",
      alignItems:"center"
  }),
};
const { Option } = components;
const IconOption = props => (
    <Option {...props}>
      <div className="avatar"
        style={{backgroundImage:`url(${props.data.avatar_url||require("../../assets/media/user.png")})` }}
        alt={props.data.label}
      />
      {props.data.label}
    </Option>
  );


const SelectUserModal = ({users, onOpenChat})=>{
    const [options,setOptions] = useState([]);
    const [selectedUser,setSelectedUser] = useState();

    useEffect(()=>{
        console.log("users in modal",users);
        let options = users.map(user=>{
          return {value:user,label:user.firstname,avatar_url:user.avatar_url}
        })
        options.sort((a,b)=>{
          if(a.avatar_url)
            return -1;
          else
            return 1;
        });
        setOptions(options);
    },[users])
    
    function handleChange(selected){
        setSelectedUser(selected);
    }
   
    return (
      <div
        className="modal fade"
        id="select_user_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title">New chat</p>
              <button
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="form-group">
                  <Select
                      options={options}
                      components={{ Option: IconOption,DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                      styles={Styles}
                      placeholder="Select community members"
                      value={selectedUser}
                      noOptionsMessage={()=>null}
                      onChange={handleChange}
                  />
                </div>
                <div className="row-div" style={{justifyContent:"space-around"}}>
                  <button
                    className="btn btn-orange"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    className="btn btn-green"
                    data-dismiss="modal"
                    onClick={()=>onOpenChat(selectedUser)}
                  >
                    Open Chat
                  </button>
                  
                </div>
               
            </div>
          </div>
        </div>
      </div>
    );
}

export default SelectUserModal;


// WEBPACK FOOTER //
// ./src/screens/ChatSuite/SelectUserModal.js